import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { Position } from '@synergy/models';

export class PositionsApi {
    constructor(protected baseUrl: string) {}

    public cget = async (
        params?: URLSearchParams,
        abortSignal?: AbortSignal
    ): Promise<ApiResult<PaginatedResponse<Position>>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/positions`, { params, signal: abortSignal }),
            response => response.data
        );
    };

    public updatePosition = async (position: Partial<Position>): Promise<ApiResult<Position>> => {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/positions/${position.id}`, position),
            response => response.data
        );
    };

    public createPosition = async (position: Partial<Position>): Promise<ApiResult<Position>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/positions`, position),
            response => response.data
        );
    };

    public deletePosition = async (positionId: number): Promise<ApiResult<Position>> => {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/positions/${positionId}`),
            response => response.data
        );
    };
}
